import * as React from 'react';
import { NoNavigationPageWrapper } from '../../../designSystem/layouts/pageWrappers/NoNavigationPageWrapper';
import { SingleColumnLayout } from '../../../designSystem/layouts/SingleColumnLayout';
import { Button } from '../../../designSystem/button/Button';
import { PageHeader } from '../../../designSystem/PageHeader';
import { buildTranslator, CustomForm, rng } from '../../../amorg-common';
import { Redirect, useParams } from 'react-router-dom';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { getCustomFormPublic, startCustomFormAnswerPublic } from '../../../api/customFormClientApi';
import { P } from '../../../designSystem/typography/Body';
import { ButtonRow } from '../../../designSystem/button/ButtonRow';
import { PublicPageProvider } from '../../_contexts/PublicPageContext';

export function CustomFormStartAnswerPagePublic (): JSX.Element
{
    const params = useParams<{ key: string, siteId: string; }>();

    const [state, setState] = React.useState<{
        loading: boolean,
        form: CustomForm,
        answerId: string;
    }>({
        loading: true,
        form: null,
        answerId: ''
    });

    React.useEffect(() =>
    {
        const getData = async () =>
        {
            const form = await getCustomFormPublic(params.key, params.siteId);
            setState({ loading: false, form, answerId: '' });
        };
        getData();
    }, [params.key, params.siteId]);

    async function handleClickStart ()
    {
        setState({ ...state, loading: true });
        const answerId = rng.getRandomId();
        const answerResult = await startCustomFormAnswerPublic(params.key, params.siteId, answerId);
        if (answerResult.isSuccess)
        {
            setState({ ...state, answerId, loading: false });
        }

    }

    const translator = buildTranslator('da');

    return (

        <PublicPageProvider>
            <NoNavigationPageWrapper>
                <SingleColumnLayout
                    noDivider
                    contentContainer={
                        <>

                            {state.answerId &&
                                <Redirect to={`/customForms/public/${params.siteId}/${state.answerId}`} />
                            }


                            <LoadingPageOverlay loading={state.loading} />

                            {state.form &&
                                <article>
                                    <PageHeader headerText="Opret ny besvarelse" headerStyle="secondary-gray" />
                                    <P verticalMargin='40px' style={{ whiteSpace: 'pre-wrap' }}>{translator(state.form?.introText)}</P>


                                    <ButtonRow variant='stretched'>
                                        <Button variant="filled" size='magnum' text="Opret en besvarelse"
                                            onClick={handleClickStart} />
                                    </ButtonRow>
                                </article>
                            }

                        </>
                    } />

            </NoNavigationPageWrapper>
        </PublicPageProvider>
    );
}